export const PRIZM_CURRENT_VERSION = '1.16.0';
